import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';
import { useRef } from 'react';

export const AU_LOCALISATION_KEY = 'en-AU';

type MetadataContentfulFields = {
  [key: string]: {
    [key: 'en-AU' | string]: any;
  };
};

export const stripLocalisation = <T extends ContentfulEntry<any>>(
  entry: MetadataContentfulFields,
  localisationKey: string
): T['fields'] => {
  return Object.entries(entry).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value?.[localisationKey] ?? value,
    }),
    {}
  );
};

const parseContentfulDataString = <T extends ContentfulEntry<any>>(dataString?: string): T | undefined => {
  try {
    return JSON.parse(decodeURIComponent(dataString ?? '')) as T;
  } catch (err) {
    console.log('Error parsing contentful data string', err);
  }
  return undefined;
};

export const useContentMetafieldData = <T extends ContentfulEntry<any>>(): T => {
  const contentfulData = useRef(parseContentfulDataString<T>(window?.Jbhifi?.contentfulDataString));
  if (!contentfulData.current) {
    throw new Error('Could not find contentful data on window');
  }
  return {
    sys: contentfulData.current.sys,
    metadata: contentfulData.current.metadata,
    fields: stripLocalisation(contentfulData.current.fields || {}, AU_LOCALISATION_KEY),
  } as T;
};
